import { LOOK_SPEED_RANGE, type Settings } from "../game/settings";

// Sound and controls, in the pause menu and on the job board.

export function SettingsPanel({ settings, onChange }: { settings: Settings; onChange: (s: Settings) => void }) {
  return (
    <div className="space-y-3 text-sm">
      <label htmlFor="setting-volume" className="block">
        <span className="flex justify-between font-semibold">
          Sound <span className="font-normal text-ink-soft tabular-nums">{settings.volume === 0 ? "Off" : `${Math.round(settings.volume * 100)}%`}</span>
        </span>
        <input
          id="setting-volume"
          type="range"
          min={0}
          max={100}
          step={5}
          value={Math.round(settings.volume * 100)}
          onChange={(e) => onChange({ ...settings, volume: Number(e.target.value) / 100 })}
          className="mt-1 w-full accent-accent"
        />
      </label>
      <label htmlFor="setting-look" className="block">
        <span className="flex justify-between font-semibold">
          Look speed <span className="font-normal text-ink-soft tabular-nums">{settings.lookSpeed.toFixed(1)}×</span>
        </span>
        <input
          id="setting-look"
          type="range"
          min={LOOK_SPEED_RANGE[0]}
          max={LOOK_SPEED_RANGE[1]}
          step={0.1}
          value={settings.lookSpeed}
          onChange={(e) => onChange({ ...settings, lookSpeed: Number(e.target.value) })}
          className="mt-1 w-full accent-accent"
        />
      </label>
      <label htmlFor="setting-invert" className="flex items-center gap-2 font-semibold">
        <input
          id="setting-invert"
          type="checkbox"
          checked={settings.invertY}
          onChange={(e) => onChange({ ...settings, invertY: e.target.checked })}
          className="size-4 accent-accent"
        />
        Invert up and down
      </label>
    </div>
  );
}
